﻿
import { ReCaptchaComponent } from '../components/ReCaptchaComponent.js';

const SELECTORS = Object.freeze({
    NOTIFICATION_CLASS: 'field-error-message text-danger field-validation-error mt-2 js-recaptha-notification active',
    CAPTCHA_SELECTOR: '.js-captcha',
    SUBMIT_BUTTON_SELECTOR: '#registerSubmit',
    RECAPTCHA_INPUT_SELECTOR: '.g-recaptcha-input'
});

const createNotification = (message, className) => {
  const notification = document.createElement('div');
  notification.textContent = message;
  className.split(' ').forEach(cls => notification.classList.add(cls));
  notification.style.display = 'none'; // Initially hidden
  return notification;
};

const insertNotification = (form, notification, captchaSelector, submitSelector) => {
    const captchaElement = form.querySelector(captchaSelector);
    const submitElement = form.querySelector(submitSelector);

    if (captchaElement && captchaElement.nextSibling) {
        captchaElement.parentNode.insertBefore(notification, captchaElement.nextSibling);
    } else if (submitElement) {
        submitElement.parentNode.insertBefore(notification, submitElement);
    } else {
        form.appendChild(notification); // Fallback
    }
};

const getOrCreateNotification = (form, message, className, captchaSelector, submitSelector) => {
    const existingNotification = form.querySelector(`.js-recaptha-notification`);
    if (existingNotification) return existingNotification;

    const newNotification = createNotification(message, className);
    insertNotification(form, newNotification, captchaSelector, submitSelector);
    return newNotification;
};

function waitForReCaptcha(callback) {
    if (typeof grecaptcha === "object" && typeof grecaptcha.render === "function") {
        callback();
    } else {
        console.warn("reCAPTCHA API not ready or incomplete. Retrying...");
        setTimeout(() => waitForReCaptcha(callback), 100);
    }
}

function toggleVisibility(container, state) {
    
    if (state) {
        container.style.display = "block";
    } else {
        container.style.display = "none"; 
    }
}

export const preventFormSubmit = (selector, reCaptchaComponent, options = {}) => {
    const form = document.querySelector(selector);

    if (!form) {
        console.error(`Form with selector "${selector}" not found.`);
        return;
    }

    const {
        captchaSelector = SELECTORS.CAPTCHA_SELECTOR,
        submitSelector = SELECTORS.SUBMIT_BUTTON_SELECTOR,
        notificationClass = SELECTORS.NOTIFICATION_CLASS,
        notificationMessage = 'Please complete the reCAPTCHA.',
    } = options;

    form.addEventListener("submit", async (event) => {
        event.preventDefault();

        const token = reCaptchaComponent.token;
        if (!token) {
            const notification = getOrCreateNotification(
                form,
                notificationMessage,
                notificationClass,
                captchaSelector,
                submitSelector
            );
            toggleVisibility(notification, true);
            return;
        }

        const reCaptchaInput = form.querySelector(".g-recaptcha-input");
        reCaptchaInput.value = token;
   
        form.submit();
    });
}

function renderCaptcha(selector) {
    const reCaptcha = new ReCaptchaComponent(selector);
    reCaptcha.initCaptcha(_ReCaptchaSiteKey);
    return reCaptcha;
}

document.addEventListener('DOMContentLoaded', () => {

    waitForReCaptcha(() => {
        const reCaptcha = renderCaptcha(".js-captcha");
        if (!reCaptcha) {
            console.error("Failed to initialize reCAPTCHA. Please check configuration.");
            return;
        }
        preventFormSubmit("#registerForm", reCaptcha);
    });
});